import { Loader, Pill, Tooltip } from '@recruit-robin/robin-theme/web-components';
import { LinkBroken, Plus } from '@recruit-robin/robin-theme/web-icons';
import { useContext, useMemo, useState } from 'react';

import type { CreateJobProps } from './CreateJob.types';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useStyles } from './CreateJob.styles';

export const CreateJob = ({ customCss, selectedVacancy, onDisconnectVacancy, onCreateJob }: CreateJobProps) => {
  const { dictionary } = useContext(LocalizationContext);
  const classes = useStyles({ contained: false });
  const [isRemovingVacancy, setIsRemovingVacancy] = useState(false);

  const disconnectVacancyButton = useMemo(() => {
    if (!onDisconnectVacancy || !selectedVacancy) return null;

    const handleDisconnectVacancy = async () => {
      try {
        setIsRemovingVacancy(true);
        await onDisconnectVacancy(selectedVacancy);
      } finally {
        setIsRemovingVacancy(false);
      }
    };

    return (
      <Tooltip label={dictionary.detachJob} zIndex={3} offset={8}>
        <Pill
          customCss={classes.disconnectJobPill}
          startIcon={
            isRemovingVacancy ? <Loader size={14} color={(c) => c.neutral.variant} /> : <LinkBroken size={14} />
          }
          style="filter-tag"
          type="subtle-light"
          onClick={handleDisconnectVacancy}
        />
      </Tooltip>
    );
  }, [onDisconnectVacancy, selectedVacancy, classes.disconnectJobPill, isRemovingVacancy]);

  return (
    <div css={[classes.createJobPill, customCss]}>
      <Pill
        startIcon={<Plus size={14} />}
        label={dictionary.createNewJob}
        style="filter-tag"
        type="subtle-light"
        onClick={onCreateJob}
      />

      {disconnectVacancyButton}
    </div>
  );
};
